import React, { Component } from "react";
import * as Constants from "../../Constants/index";
import axios from "axios";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import Pagination from "react-js-pagination";
import Footer from "../footer/footer.component";
import CreateCategories from "./createprogramBanners.component";

class ProgramBanners extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
  }

  state = {
    name: "",
    sortBy: "name",
    limit: 25,
    totalResults: 0,
    page: 1,
    Categorys: [],
    search: "",
    create: 0,

    // ✅ NEW STATES
    showModal: false,
    selectedImage: "",
  };

  componentDidMount() {
    this.fetchBanners();
  }

  fetchBanners = async () => {
    try {
      const token = localStorage.getItem("token");
      const currentURL = window.location.pathname;
      const parts = currentURL.split("/");
      let programid = parseInt(parts.pop());

      const pathSegments = window.location.pathname.split("/");
      let compid = pathSegments[pathSegments.length - 2];

      let url = this.state.search !== ""
        ? `program/banner?name=${this.state.search}&sortBy=${this.state.sortBy}&limit=${this.state.limit}&page=${this.state.page}`
        : `program/banner?sortBy=${this.state.sortBy}&limit=${this.state.limit}&page=${this.state.page}`;

      const resp = await axios.get(Constants.api + url, {
        headers: {
          Authorization: `Bearer ${token}`,
          company: compid,
          program: programid,
          platform: Constants.pt,
          appVersion: Constants.av,
        },
      });

      if (resp.status === 201 && resp.data.result !== "error") {
        this.setState({
          Categorys: resp.data.output.results,
          totalResults: resp.data.output.totalResults,
        });
      } else if (resp.status === 403) {
        localStorage.removeItem("userid");
        window.location.href = "/";
      }
    } catch (err) {
      console.error(err);
    }
  };

  searchHandleChange = (event) => {
    this.setState({ search: event.target.value, page: 1 }, this.fetchBanners);
  };

  limitHandleChange = (event) => {
    const limit = parseInt(event.target.value, 10);
    this.setState({ limit, page: 1 }, this.fetchBanners);
  };

  handlePageChange = (pageNumber) => {
    this.setState({ page: pageNumber }, this.fetchBanners);
  };

  handleViewMode = (data) => {
    this.setState({ create: data }, this.fetchBanners);
  };

  // ✅ MODAL HANDLERS
  handleOpenModal = (url) => {
    this.setState({
      showModal: true,
      selectedImage: url,
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      selectedImage: "",
    });
  };

  render() {
    const editItem = (id) => {
      const token = localStorage.getItem("token");

      axios
        .get(Constants.api + "program/banner/" + id, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((resp) => {
          if (resp.status === 200) {
            this.setState({ create: 1, resp: resp });
          }
        });
    };

    const CategorysRender = this.state.Categorys.map((item, i) => {
      return (
        <tr key={i}>
          <td>{item.id}</td>
          <td>{item.name}</td>

          {/* ✅ VIEW BUTTON */}
          <td>
            <button
              className="btn btn-sm btn-info"
              onClick={() => this.handleOpenModal(item.url)}
            >
              View
            </button>
          </td>

          <td>{item.active ? "Active" : "Deactive"}</td>
          <td>{item.createDateTime}</td>
          <td>{moment(item.updatedAt).format("DD/MM/YY h:ma")}</td>

          <td>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => editItem(item.id)}
            >
              Edit
            </button>
          </td>
        </tr>
      );
    });

    return (
      <>
        {this.state.create === 0 ? (
          <>
            <main className="main-content">
              <div className="container-fluid py-4">
                <div className="card">
                  <div className="card-header d-flex justify-content-between">
                    <h5>All Banners</h5>

                    <button
                      className="btn btn-primary"
                      onClick={() => this.setState({ create: 1 })}
                    >
                      Add New
                    </button>
                  </div>

                  <div className="card-body">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control mb-3"
                      onChange={this.searchHandleChange}
                    />

                    <table className="table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Banner</th>
                          <th>Status</th>
                          <th>Created</th>
                          <th>Updated</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>{CategorysRender}</tbody>
                    </table>

                    <Pagination
                      activePage={this.state.page}
                      itemsCountPerPage={this.state.limit}
                      totalItemsCount={this.state.totalResults}
                      onChange={this.handlePageChange}
                    />
                  </div>
                </div>

                <Footer />
              </div>
            </main>

            {/* ✅ MODAL */}
            {this.state.showModal && (
              <div
                className="modal show fade"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.6)",
                }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5>Banner Preview</h5>
                      <button
                        style={{ backgroundColor: "black", color: "black" }}
                        className="btn-close"
                        onClick={this.handleCloseModal}
                      ></button>
                    </div>

                    <div className="modal-body text-center modal-content">
                      <img
                        src={this.state.selectedImage}
                        alt="banner"
                        style={{ width: "100%", borderRadius: "10px" }}
                      />
                    </div>

                    {/* <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={this.handleCloseModal}
                      >
                        Close
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
            )}
          </>
        ) : this.state.resp ? (
          <CreateCategories
            resp={this.state.resp}
            setViewMode={this.handleViewMode}
          />
        ) : (
          <CreateCategories setViewMode={this.handleViewMode} />
        )}
      </>
    );
  }
}

export default ProgramBanners;